import React from 'react';
import { TColumn } from './types';
import { CapitalizeNames } from 'src/utils/capitalize';
import { useTranslation } from 'react-i18next';

interface IStringArray {
    column: TColumn;
    item: any;
}

export const StringArray = ({ column, item }: IStringArray) => {
    const { t } = useTranslation();
    const { translationField } = column;
    return (
        <div style={{ minWidth: column.width || '25ch' }}>
            {item[column.field].map((fieldValue: string, index: number) => (
                <React.Fragment key={fieldValue || index}>
                    {translationField ? <p>{t(translationField.replace('{{field}}', fieldValue))}</p> : <p>{CapitalizeNames(fieldValue)}</p>}
                    {index < item[column.field].length - 1 && <br />}
                </React.Fragment>
            ))}
        </div>
    );
};
